export default "__VITE_ASSET__xf6cqlMN__"